<template>
  <main>
    <div class="container">
      <!-- 切換標題 -->
      <div class="tab_title" :class="{ jp: $region === 'jp' }">
        <a
          class="cate news_title"
          ga-data="1010101"
          :class="{ jp: $region === 'jp' }"
        >
          <p>{{ $t("news.newsNotice") }}</p>
          <div class="focus_dot"></div>
        </a>
        <a
          @click="$router.push({ name: 'active' })"
          class="cate event_title"
          :class="{ jp: $region === 'jp' }"
        >
          <p class="gray">{{ $t("news.newActive") }}</p>
        </a>
      </div>

      <!-- 公告聲明 -->
      <div
        class="notice"
        :class="{ jp: $region === 'jp' }"
        v-if="topNews.statement"
      >
        <h4>
          <!-- Komoe Game {{$t('news.noticeDeclare')}} -->
          {{ topNews.statement.title }}
          <span class="imp">{{ $t("news.important") }}</span>
          <span class="date" v-html="topNews.statement.publish_time"></span>
        </h4>
        <p v-html="topNews.statement.content"></p>
      </div>

      <!-- 新聞timeline -->
      <div class="newsline">
        <!-- 置頂新聞 -->
        <div class="mount_block" v-if="topNews && topNews.top_image_large">
          <div class="title">
            {{ $t("news.newsAtt") }}
            <div class="separate"></div>
            <hr />
          </div>
          <div class="list">
            <!-- 大圖新聞 -->
            <!-- :href="topNews.top_image_large.url||'/newsdetail/#'+topNews.top_image_large.news_id" -->
            <a
              @click="
                toDetail({
                  url: topNews.top_image_large.url,
                  id: topNews.top_image_large.news_id,
                })
              "
              class="notice_item"
              v-if="topNews.top_image_large"
            >
              <div
                class="img_box"
                :style="{
                  backgroundImage:
                    'url(' + topNews.top_image_large.image_small + ')',
                }"
              ></div>
              <div class="info_box">
                <h4 v-html="topNews.top_image_large.title"></h4>
                <p v-html="topNews.top_image_large.summary"></p>
                <div class="bottom">
                  <span
                    class="type"
                    v-text="getNewsType(topNews.top_image_large.type)"
                  ></span>
                  <span
                    class="date"
                    v-html="getDateString(topNews.top_image_large.publish_time)"
                  ></span>
                </div>
              </div>
            </a>
            <!-- 小圖新聞 -->
            <template
              v-if="
                topNews.top_image_small_list &&
                  topNews.top_image_small_list.length > 0
              "
            >
              <!-- :href="n.url||'/newsdetail/#'+n.news_id" -->
              <a
                class="notice_item"
                v-for="n in topNews.top_image_small_list"
                @click="
                  toDetail({
                    url: n.url,
                    id: n.news_id,
                  })
                "
                :key="n.news_id"
              >
                <div
                  class="img_box"
                  :style="{ backgroundImage: 'url(' + n.image_small + ')' }"
                ></div>
                <div class="info_box">
                  <h4 v-html="n.title"></h4>
                  <p v-html="n.summary"></p>
                  <div class="bottom">
                    <span class="type" v-text="getNewsType(n.type)"></span>
                    <span
                      class="date"
                      v-html="getDateString(n.publish_time)"
                    ></span>
                  </div>
                </div>
              </a>
            </template>
            <!-- 置頂新聞 -->
            <template
              v-if="topNews.top_news_list && topNews.top_news_list.length > 0"
            >
              <!-- :href="n.url||'/newsdetail/#'+n.news_id" -->
              <a
                class="notice_item"
                v-for="n in topNews.top_news_list"
                @click="
                  toDetail({
                    url: n.url,
                    id: n.news_id,
                  })
                "
                :key="n.news_id"
              >
                <div class="notice_tit">
                  <span class="type" v-html="getNewsType(n.type)"></span>
                  <p v-html="n.title"></p>
                  <span
                    class="date"
                    v-html="getDateString(n.publish_time)"
                  ></span>
                </div>
              </a>
            </template>
          </div>
        </div>
        <!-- 普通新聞 -->
        <div class="mount_block" v-for="m in month_list" :key="m.month">
          <div class="title">
            {{ m.month }}
            <div class="separate"></div>
            <hr />
          </div>
          <div class="list">
            <a
              class="notice_item"
              v-for="n in m.items"
              :key="n.news_id"
              @click="
                toDetail({
                  url: n.url,
                  id: n.news_id,
                })
              "
            >
              <!-- :href="n.url||'/newsdetail/#'+n.news_id" -->
              <!-- <span class="timer" v-text="getMonthString(n.publish_time)"></span> -->
              <div class="notice_tit">
                <span class="type" v-text="getNewsType(n.type)"></span>
                <p v-text="n.title"></p>
                <span class="icon">
                  <img
                    src="../../assets/images/news/arrow_right_circle.svg"
                    alt
                  />
                </span>
              </div>
            </a>
          </div>
        </div>
        <!-- 查看更多 -->
        <div
          v-if="have_more"
          class="show_more"
          @click="getNews"
          ga-data="203002"
        >
          {{ $t("news.checkMore") }}
          <span class="icon">
            <img src="../../assets/images/news/arrow_down_circle.svg" alt />
          </span>
        </div>

        <div v-else class="show_more gray">
          <span v-if="$region !== 'jp'">{{ $t("news.noMoreNews") }}</span>
        </div>
      </div>

      <!-- 回到顶部 -->
      <span
        class="toTop"
        v-if="scrollTopHigth > 600"
        @click="scrollsotp"
      ></span>
    </div>
  </main>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      topNews: {},
      newsList: [],
      month_list: [],
      totop: false,
      page_num: 1,
      have_more: true,
      scrollTopHigth: 0,
    };
  },
  methods: {
    toDetail(param) {
      if (param.url) {
        window.location.href = param.url;
      } else {
        this.$router.push({ name: "newsDetail", params: { id: param.id } });
      }
    },
    getNewsType(id) {
      switch (id) {
        case 1:
          return this.$t("news.notice");
        // break;
        case 2:
          return this.$t("news.preserve");
        // break;
        case 3:
          return this.$t("news.news");
        // break;
        case 4:
          return this.$t("news.active");
        // break;
        case 5:
          return this.$t("news.declare");
        // break;
        default:
          return id;
        // break;
      }
    },
    getNews() {
      this.$apis.home.getNewsList(this.page_num, 20).then((data) => {
        let res = data.data;
        // console.log("news",res)
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.newsList.push(...res.data);
            this.page_num++;
            this.handleNews(res.data);
          } else {
            this.have_more = false;
          }
        } else {
          // console.error(res.message);
        }
      });
    },
    handleNews(nl) {
      let months = this.month_list;
      // console.log("months0",nl)
      nl.forEach((i) => {
        // console.log("months1",i)
        let new_one = true;
        months.forEach((j) => {
          // console.log("months2",j)
          if (j.month == this.getMonthString(i.publish_time)) {
            j.items.push(i);
            new_one = false;
          }
        });
        if (new_one) {
          // console.log("months3",new_one)
          months.push({
            month: this.getMonthString(i.publish_time),
            items: [i],
          });
        }
      });
      // console.log("months",months)
      // this.month_list = months
    },
    // handleScroll() {
    //   if (
    //     self.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop
    //   ) {
    //     this.totop = true;
    //   } else {
    //     this.totop = false;
    //   }
    // },
    getDateString(t) {
      if (!t) {
        return 0;
      }
      let ts = new Date(t);
      // let zero = ts.getMonth()+1>9?"":"0"
      let addzero = (i) => {
        if (i > 9) {
          return String(i);
        } else {
          return "0" + i;
        }
      };
      return (
        ts.getFullYear() +
        "-" +
        addzero(ts.getMonth() + 1) +
        "-" +
        addzero(ts.getDate())
      );
    },
    getMonthString(t) {
      if (!t) {
        return 0;
      }
      let ts = new Date(t);
      let zero = ts.getMonth() + 1 > 9 ? "" : "0";
      return ts.getFullYear() + "-" + zero + (ts.getMonth() + 1);
    },
    scrollsotp() {
      const currentY =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollAnimation(currentY, 0);
    },
    scrollAnimation(currentY, targetY) {
      // 获取当前位置方法
      // 计算需要移动的距离
      let needScrollTop = targetY - currentY;
      let _currentY = currentY;
      setTimeout(() => {
        // 一次调用滑动帧数，每次调用会不一样
        const dist = Math.ceil(needScrollTop / 10);
        _currentY += dist;
        window.scrollTo(_currentY, currentY);
        // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.scrollAnimation(_currentY, targetY);
        } else {
          window.scrollTo(_currentY, targetY);
        }
      }, 1);
    },
    listenerFunction() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    handleScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.scrollTopHigth = scrollTop;
    },
  },
  mounted() {
    this.listenerFunction();
    // 请求置顶新闻
    this.$apis.home.getNewsTop().then((data) => {
      let res = data.data;
      // console.log("topnews",res)
      if (res.code == 0) {
        this.topNews = res.data;
      } else {
        // console.error(res.message);
      }
    });
    this.getNews();

    // window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
};
</script>

<style lang="scss" scoped>
.contact-container {
  min-width: 1200px;
}
.main-block {
  width: 100%;
  max-width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  font-size: 20px;
}
.main-tit {
  height: 112px;
  padding-top: 80px;
  text-align: center;
  border-bottom: 1px solid #ccc;
  .tit-slice {
    width: 24px;
    height: 4px;
    background: #50bbe5;
    border-radius: 100px;
    vertical-align: middle;
  }
  .tit-en-des {
    font-size: 14px;
    color: #cccccc;
    letter-spacing: 0;
    line-height: 17px;
  }
  .tit-des {
    font-size: 32px;
    color: #444444;
    letter-spacing: 0;
  }
  span {
    display: inline-block;
  }
}
.main-con {
  .con-tit {
    padding-top: 61px;
    font-size: 24px;
    font-weight: bold;
    color: #50bbe5;
    line-height: 31px;
  }
  .con-block {
    padding-top: 30px;
    color: #444;
  }
  .con-about {
    font-size: 14px;
    line-height: 28px;
  }
}

div,
p,
h4,
h5,
span {
  margin: 0;
  padding: 0;
}
a {
  color: inherit;
  text-decoration: none;
}
span {
  font-weight: normal;
  &.imp {
    display: inline-block;
    width: 50px;
    line-height: 16px;
    background: #ffb13b;
    border-radius: 8px;
    color: #ffffff;
    font-size: 12px;
    text-align: center;
  }
  &.date {
    display: inline-block;
    font-size: 12px;
    color: #999999;
  }
  &.type {
    display: inline-block;
    width: 50px;
    line-height: 16px;
    height: 16px;
    background: #50bbe5;
    border-radius: 8px;
    color: #ffffff;
    font-size: 12px;
    text-align: center;
  }
}
main {
  min-width: 1366px;
}
.container {
  width: 1170px;
  margin: 0 auto;
  padding-top: 80px;
  box-sizing: border-box;
  min-height: calc(100vh - 242px);
  .tab_title {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    margin-bottom: 40px;
    &.jp {
      text-align: left;
      .cate {
        margin-right: 80px;
        p {
          font-size: 24px;
        }
        .focus_dot {
          height: 2px;
        }
      }
    }
    .cate {
      display: inline-block;
      width: 188px;
      position: relative;
      cursor: pointer;
      &.jp {
        width: auto;
      }
      p {
        font-size: 32px;
        color: #444444;
        margin-bottom: 24px;
        &.gray {
          color: #bdbdbd;
        }
      }
      .focus_dot {
        margin: 0 auto;
        width: 32px;
        height: 6px;
        border-radius: 3px;
        background: #50bbe5;
      }
    }
  }
  .notice {
    border: 1px solid #eeeeee;
    border-radius: 10px;
    padding: 30px 20px;
    margin-bottom: 40px;
    &.jp {
      padding: 30px 0;
      border: none;
      p {
        word-break: break-all;
      }
    }
    h4 {
      font-size: 20px;
      color: #333333;
      margin-bottom: 20px;
      .date {
        float: right;
      }
    }
    p {
      font-size: 14px;
      color: #999999;
      text-indent: 2em;
    }
  }
  .newsline {
    border-top: 1px solid #eeeeee;
    .mount_block {
      border-bottom: 1px solid #eeeeee;
      position: relative;
      .title {
        position: absolute;
        top: 30px;
        left: 0;
        width: 150px;
        font-size: 20px;
        line-height: 24px;
        color: #cccccc;
        hr {
          float: right;
          display: block;
          width: 50px;
          border: 0;
          height: 2px;
          background: #eeeeee;
          margin-top: 11px;
        }
        .separate {
          float: right;
          display: block;
          width: 5px;
          height: 24px;
          border-radius: 3px;
          background: #bdbdbd;
        }
      }
      .list {
        border-left: 1px solid #eeeeee;
        padding: 0 52px;
        margin-left: 147px;
        .notice_item {
          cursor: pointer;
        }
        a {
          display: block;
          padding: 20px 0;
          border-bottom: 1px solid #eeeeee;
          text-decoration: none;
          color: #444444;
          overflow: hidden;
          position: relative;
          .img_box {
            float: left;
            width: 220px;
            height: 124px;
            border-radius: 10px;
            background: black;
            margin-right: 28px;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
          }
          .info_box {
            height: 124px;
            position: relative;
            width: 670px;
            float: right;
            &:hover {
              h4 {
                color: #50bbe5;
              }
            }
            h4 {
              font-size: 20px;
              color: #444444;
              margin-bottom: 10px;
            }
            p {
              font-size: 12px;
              color: #999999;
              line-height: 18px;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              display: -webkit-box;
              height: 54px;
            }
            .bottom {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 670px;
              .date {
                float: right;
              }
            }
          }
          .notice_tit {
            display: flex;
            align-items: center;
            cursor: pointer;
            span {
              flex-grow: 0;
              flex-shrink: 0;
              &.icon {
                width: 12px;
                img {
                  display: block;
                  border-radius: 6px;
                }
              }
            }
            p {
              flex-grow: 1;
              font-size: 16px;
              color: #444444;
              margin-left: 20px;
              padding: 9px 21px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &:hover {
              p {
                color: #50bbe5;
              }
              img {
                box-shadow: 0 0 4px #50bbe5;
              }
            }
          }
          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
    .show_more {
      text-align: center;
      font-size: 16px;
      line-height: 80px;
      color: #444444;
      padding-bottom: 120px;
      cursor: pointer;
      &.gray {
        color: #cccccc;
      }
      img {
        width: 12px;
      }
    }
  }
  .toTop {
    display: block;
    position: fixed;
    width: 48px;
    height: 64px;
    left: 50%;
    bottom: 80px;
    margin-left: 615px;
    background: url(../../assets/images/news/totop_nor.svg) center center
      no-repeat;
    background-size: contain;
    cursor: pointer;
    &:hover {
      background-image: url(../../assets/images/news/totop_hover.svg);
    }
    &:active {
      background-image: url(../../assets/images/news/totop_pressed.svg);
    }
  }
}
</style>
